import type { FillReport } from '@/api/signalR/messages/execution.ts';
import { fillReportReceived } from '@/store/growl/slice.ts';
import type { DealExecutionId } from '@/store/growl/state/common.ts';
import type { AppDispatch } from '@/store/store.ts';

/**
 * Handles a fill report that arrives *after* the execution request is over — the corrective report
 * carrying the real trade id of a deal Multipass first reported as `NOT_YET_INTEGRATED`.
 *
 * It deliberately does nothing but update the growl. Every other effect of a fill report
 * (`removeMutationResult`, `xxxExecutionSuccess`) belongs to the execution request: by then the
 * cache entry is gone and the tile may already be running another execution, which replaying those
 * effects would corrupt.
 */
export const buildHandleLateFillReport =
  (growlId: DealExecutionId, dispatch: AppDispatch) =>
  (fillReport: FillReport): void => {
    const { ExecutionId, RfsId } = fillReport.Execute;

    if (ExecutionId !== growlId && RfsId !== growlId) {
      return;
    }

    dispatch(fillReportReceived({ growlId, tradeIds: fillReport.BackOfficeReply.TradeIds }));
  };
